export interface SubscriptionPlan {
    id: string,                 
    subscriptionTerm: Subscriptionterm,
    price: number,              
    crossedOutPriceText: string,
    crossedOutPriceValue: string
    showedDiscountText: string, 
    showedDiscountValue: string,
    displayedTotalText: string, 
    displayedTotalValue: string 
}

export enum Subscriptionterm {
    Monthly = 1,
    Annual = 2,
}